import './survey_timeseries_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.SurveyRequestsTimeseriesView extends Monitoring.Views.Charts.SurveyTimeseriesView
  apiUrl: '/monitoring/api/charts/survey_requests'
  name: 'survey_requests'
  chartOptions:
    colors: ['#FFA500']

  initialize: (@options = {}) ->
    @title = I18n.t('monitoring.dashboard.charts.survey_timeseries.requests')
    @title_en = I18n.t('monitoring.dashboard.charts.survey_timeseries.requests', {'locale': 'en'})
    @searchQuery = @options.searchQuery
    @getDateStats()
    super(@options)

  getDateStats: ->
    $.ajax({
      type: 'POST'
      url: @apiUrl + '/date_stats'
      data: @searchQuery.deepCopy().toJSON()
      async: false
      success: (response) =>
        @options.facets['date'] = response.date_stats
    })

  _dataIsEmpty: ->
    @initialTime == null || @finalTime == null
